import { render } from "./ShowCustomerReturnReason.vue?vue&type=template&id=c6e1c182"
import script from "./ShowCustomerReturnReason.vue?vue&type=script&lang=js"
export * from "./ShowCustomerReturnReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__